module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1502-ec8fd4a562c6117b55a5f98530401a7f.png";